import React from 'react';

import Loading from './components/loading.component'
import LoadingMobile from './componentsMobile/loading.component';
import { syncStrapiRuntime } from './helpers/strapi.helper';

//import mobileAndTabletCheck from './utils/mobileCheck';

interface Props {}

interface State {
  isMobile: boolean;
  synced: boolean;
}

class App extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      isMobile: false,
      synced: false
    }
  }

  componentDidMount(): void {
    var check = window.innerHeight > window.innerWidth
    this.setState({
      isMobile: check
    })

    this.setState({ synced: true });

    window.addEventListener("resize", () => {
      var currentSize = this.state.isMobile
      this.setState({
        isMobile:
          window.innerHeight > window.innerWidth,
      }, () => {
        if(currentSize !== this.state.isMobile){
          window.location.reload()
        }
      });
    });
  }

  render(): React.ReactNode {
      const key = this.state.synced ? 'synced' : 'pending';
      return(
        <div className='interactive-car-container' key={key}>
          {
            !this.state.isMobile ?
            <Loading/>:
            <LoadingMobile/>
          }
        </div>
      )
  }
}

export default App;
